module.exports = __webpack_public_path__ + "img/expand.b9f3d6df.svg";